import register from '@kpsys/angularjs-register';
import {customElementsConfig, customElementsHtmlSanitizationConfig} from './custom-elements.config';

export default register('portaro.shared.custom-elements')
    .config(customElementsHtmlSanitizationConfig)
    .run(customElementsConfig)
    .name()